import { AutoCompleteSearchField as GammaAutoCompleteSearchField } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

type AutoCompleteSearchFieldProps = React.ComponentProps<typeof GammaAutoCompleteSearchField>

type Props = Omit<AutoCompleteSearchFieldProps, 'selectValue' | 'missingLabel'> & {
  missingLabel?: string
}

const AutoCompleteSearchField: React.FC<Props> = ({ missingLabel, ...props }) => (
  <GammaAutoCompleteSearchField
    {...props}
    missingLabel={missingLabel ?? i18n.t('common.missing_field')}
    selectValue={i18n.t('common.select')}
  />
)

export default AutoCompleteSearchField
